/**
 * @see https://wiki.migros.net/display/TSICHDDWEBCC/09+-+Quick+Search
 */

import type { SuggestSuggestionV22 } from '~/types/openapi/search-api'

export default {
  submitSearch,
  autosuggestItemSelected,
  numberPax,
  destinationSelect,
  paxSelect,
  petsSelect,
  search,
}

function submitSearch({
  text,
  date,
  duration,
  pax,
}: {
  text?: string
  date?: string
  duration?: string | number
  pax?: number
}) {
  useTracking().send({
    event: 'quick search',
    eventCategory: 'Quick Search',
    eventAction: 'Destination',
    eventLabel: text || 'empty',
    eventNonInteraction: false,
    Date: date || 'empty',
    duration: duration || 'empty',
    Persons: pax || 'empty',
  })
}

function autosuggestItemSelected({ type, label }: AutosuggestItem) {
  useTracking().send({
    event: 'quick search',
    eventCategory: 'Quick Search',
    eventAction: 'Search Suggest',
    eventLabel: label + (type ? ` / ${type}` : ''),
    eventNonInteraction: false,
  })
}

function numberPax(number: string) {
  useTracking().send({
    event: 'quick search',
    eventCategory: 'Quick Search',
    eventAction: 'Persons',
    eventLabel: number,
    eventNonInteraction: false,
  })
}

function sendEvent(data: Record<string, unknown>) {
  const condData = useConfdata()
  const route = useRoute()

  useTracking().send({
    event: 'quicksearch',
    action: undefined,
    label: undefined,
    category: undefined,
    component: 'quick-search',
    position: route.path,
    language: condData.language,
    _clear: true,
    ...data,
  })
}

function select(category: string, label: string) {
  sendEvent({ action: 'select', category, label })
}

function destinationSelect({ type, label }: SuggestSuggestionV22) {
  select('destination', label + (type ? ` / ${type}` : ''))
}

function paxSelect(pax: number) {
  select('number of guests', pax.toString())
}

function petsSelect(pets: number) {
  select('number of pets', pets.toString())
}

function search(
  destination: SuggestSuggestionV22 | undefined,
  dates: DatePeriod | undefined,
  guests: GuestsValue | undefined,
) {
  sendEvent({
    action: 'search',
    qs_destination: destination?.label,
    qs_start_date: dates?.startDate && toDate(dates.startDate),
    qs_duration: isValidDatePeriod(dates)
      ? calculateDuration(dates.startDate, dates.endDate)
      : undefined,
    qs_pax: guests?.pax || undefined,
    qs_pets: guests?.pets || undefined,
  })
}
